import {
  setMassiveCalculationKeys,
  setMassiveCalculationExcelData,
  setMassiveCalculationFileName
} from 'src/features'
import * as XLSX from 'xlsx'

export const readExcelFile = (dispatch, file, fileName) => {
  const reader = new FileReader()
  reader.onload = (evt) => {
    const bstr = evt.target.result
    const wb = XLSX.read(bstr, { type: 'binary' })
    const wsname = wb.SheetNames[0]
    const ws = wb.Sheets[wsname]
    const data = XLSX.utils.sheet_to_json(ws)
    prepareExcel(dispatch, data)
    dispatch(setMassiveCalculationFileName(fileName))
  }
  reader.readAsBinaryString(file)
}

export const prepareExcel = (dispatch, data) => {
  const finalData = []
  for (const i of data) {
    for (const x of Object.keys(i)) {
      const newKey = x.replace(/ /g, '')
      if (x.includes(' ')) {
        delete Object.assign(i, { [newKey]: i[x] })[x]
      }
    }
    finalData.push(i)
  }
  if (finalData.length > 0) {
    const keys = Object.keys(finalData[0])
    dispatch(setMassiveCalculationKeys(keys))
  }
  dispatch(setMassiveCalculationExcelData(finalData))
}
